import React, { useRef, useState } from 'react';
import { Desktop, Mobile } from '../../../App';
import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P2, P3 } from '../../../styles/FontStyles';
import { ArrowChevron, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Collapsable, HubArrow, HubImage, HubStyled } from './Hub.styled';
import { useTranslation } from 'react-i18next';
import { Flex } from '../../../styles/stylesStyled';

export const Hub = ({
  id,
  image,
  title,
  price,
  priceToShow,
  feePrice,
  vatPrice,
  button,
  weeklyCap,
  info,
  limitedQuantity,
  dobuleTradingBinaries,
  stakingHubDetails,
  condensed,
  onClick,
  selected,
  subtitle,
  tickets,
  subscriptionPrice,
  showTickets,
  type
}: any) => {
  const { t } = useTranslation('marketplace');

  const [expanded, setExpanded] = useState(false);

  const ref = useRef<any>(null);
  const elementHeight = ref?.current?.clientHeight;

  const wide = window.innerWidth > 800;

  const showSubtitleText = () => {
    if (subtitle !== null && subtitle !== undefined) {
      return (
        <>
          <Desktop>
            {showTickets ? (
              <>
                <P3 bold right caps>
                  {subtitle} <span>{tickets}</span>
                </P3>
              </>
            ) : (
              <>
                <P3 bold right caps>
                  {title === 'Bronze' || title === 'Silver' ? '' : subtitle}
                </P3>
                <P3 bold caps right color={'#307BC1'}>
                  {tickets === '+0 ticket' ? '' : tickets}
                </P3>
              </>
            )}
          </Desktop>
          <Mobile>
            <Flexed between>
              <P3 bold right caps>
                {title === 'Bronze' || title === 'Silver' ? '' : subtitle}
              </P3>
              <P3 bold caps right color={colors.secondary100}>
                {tickets === '+0 ticket' ? '' : tickets}
              </P3>
            </Flexed>
          </Mobile>
        </>
      );
    }
  };

  const showYearlyDescription = () => {
    if ((id === 2 && type === 7) || (id === 332 && type === 10)) {
      return `+ ${vatPrice} VAT + ${feePrice} FEE / lifetime`;
    } else if (id === 330 && type === 10) {
      return `+ ${vatPrice} VAT + ${feePrice} FEE`;
    } else {
      return `+ ${vatPrice} VAT + ${feePrice} FEE / yearly`;
    }
  };
  return (
    <HubStyled
      condensed={condensed}
      selected={selected}
      onClick={wide ? onClick : null}>
      <div>
        <HubImage
          condensed={condensed}
          onClick={() => setExpanded(!expanded)}
          image={image}
        />
        <div>
          <Flexed column between>
            <div>
              <Desktop>
                <H3 color={selected ? colors.primary900 : ''} mb='4'>
                  {title}
                </H3>
              </Desktop>
              <Mobile>
                <H4
                  color={expanded ? colors.primary900 : ''}
                  onClick={() => setExpanded(!expanded)}
                  mb='4'
                  mr='20'>
                  {title}
                </H4>
              </Mobile>

              <Desktop>
                {priceToShow ? (
                  <P2 mb='12' color={colors.neutral500}>
                    {priceToShow}
                  </P2>
                ) : subscriptionPrice ? (
                  <>
                    <P2 color={colors.neutral500}>
                      {formatUSDNoDecimals(price)} {USDT} Membership
                    </P2>
                    <P2 color={colors.neutral500}>
                      {formatUSDNoDecimals(subscriptionPrice)} {USDT}{' '}
                      Subscription
                    </P2>
                  </>
                ) : (
                  <P2 mb='12' color={colors.neutral500}>
                    {formatUSDNoDecimals(price)} {USDT}{' '}
                    {showYearlyDescription()}
                  </P2>
                )}
              </Desktop>

              <Mobile>
                <P3
                  onClick={() => setExpanded(!expanded)}
                  mb='12'
                  color={colors.neutral500}>
                  {priceToShow ? (
                    <P2 mb='12' color={colors.neutral500}>
                      {priceToShow}
                    </P2>
                  ) : subscriptionPrice ? (
                    <>
                      <P2 color={colors.neutral500}>
                        {formatUSDNoDecimals(price)} {USDT} Membership
                      </P2>
                      <P2 color={colors.neutral500}>
                        {formatUSDNoDecimals(subscriptionPrice)} {USDT}{' '}
                        Subscription
                      </P2>
                    </>
                  ) : (
                    <P2 mb='12' color={colors.neutral500}>
                      {formatUSDNoDecimals(price)} {USDT}{' '}
                      {title !== 'Lifetime subscription'
                        ? `+ ${vatPrice} VAT + ${feePrice} FEE / yearly`
                        : `+ ${vatPrice} VAT + ${feePrice} FEE / lifetime`}
                    </P2>
                  )}
                </P3>
              </Mobile>
            </div>
            {button}

            <HubArrow onClick={() => setExpanded(!expanded)}>
              <ArrowChevron direction={expanded ? 'up' : 'down'} />
            </HubArrow>
          </Flexed>
          <Flexed column between>
            <Flexed column>
              {weeklyCap && (
                <>
                  <P3 bold right>
                    {t('binary_weekly_cap')}
                  </P3>
                  <P3 bold right color={colors.primary900}>
                    {weeklyCap}
                  </P3>
                </>
              )}

              <P3 bold right color={colors.primary900}>
                {limitedQuantity && t('limited_quantity')}
              </P3>

              {dobuleTradingBinaries !== null &&
                dobuleTradingBinaries !== undefined && (
                  <>
                    <P3 bold right caps>
                      {dobuleTradingBinaries > 0
                        ? t('higher_trading_binary')
                        : t('trading_binary')}
                    </P3>
                    <P3 bold right color={colors.secondary100}>
                      +{dobuleTradingBinaries.toFixed(2)}%
                    </P3>
                  </>
                )}

              {showSubtitleText()}
            </Flexed>
            {info}
          </Flexed>
        </div>
      </div>
      <Collapsable expanded={expanded} elementHeight={elementHeight}>
        <Flexed
          column
          gap='16px'
          onClick={() => setExpanded(!expanded)}
          ref={ref}
          style={{ padding: 16 }}>
          {weeklyCap && (
            <P3 bold>
              {t('binary_weekly_cap')}{' '}
              <span style={{ color: colors.primary900 }}>{weeklyCap}</span>
            </P3>
          )}
          {limitedQuantity && (
            <P3 bold color={colors.primary900}>
              {limitedQuantity && t('limited_quantity')}
            </P3>
          )}

          {dobuleTradingBinaries !== null &&
            dobuleTradingBinaries !== undefined && (
              <Flexed mb={stakingHubDetails ? '12' : '0'} center gap='16px'>
                <P2 bold color={color.colors.primary900}>
                  +{dobuleTradingBinaries?.toFixed(2)}%
                </P2>
                <P2 bold caps>
                  {dobuleTradingBinaries > 0
                    ? t('higher_trading_binary')
                    : t('trading_binary')}{' '}
                </P2>
              </Flexed>
            )}

          {showSubtitleText()}

          {stakingHubDetails}
        </Flexed>
      </Collapsable>
    </HubStyled>
  );
};
